export default __webpack_public_path__ + "static/media/faden.9e502c40.ttf";